<template>
  <div class="container">
    <div class="companyTopBox">
      <div class="logoBox">
        <van-image
          :src="info.Photo"
          fit="contain"
          error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
        />
      </div>
      <div class="companyTitle">{{ info.Headline }}</div>
      <div class="saleBox" v-if="info.MainSupply">
        <div class="saleTitle">主营产品</div>
        <div class="saleInnerBox">
          <div class="saleItem">{{ info.MainSupply }}</div>
        </div>
      </div>
    </div>
    <!-- 富文本 -->
    <div class="descriptionBox" v-html="info.Introduction"></div>
    <div class="companyBox">
      <div class="introduceBox">
        <div class="introduceItem">
          <span class="title">联系人</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.TrueName }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">固定电话</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.Tel }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">传真</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.Fax }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">地址</span>
          <span style="color: #999999">：</span>
          <span class="content">{{ info.CompanyAddress }}</span>
        </div>
        <div class="introduceItem">
          <span class="title">公司主页</span>
          <span style="color: #999999">：</span>
          <span class="content" style="color: #2268e8">{{ info.Website }}</span>
        </div>
        <div class="actionBox">
          <div class="actionItem">
            <img
              class="iconImg"
              style="margin-right: 20rpx"
              src="../../../static/images/productDetail/call.png"
            />
            <div>
              <a style="color: #666" :href="'tel:' + info.Tel">打电话</a>
            </div>
          </div>
          <div class="actionItem">
            <img
              class="iconImg"
              style="margin-right: 14rpx"
              src="../../../static/images/productDetail/card.png"
            />
            <div>
              <a style="color: #666" :href="'tel:' + info.Tel">存名片</a>
            </div>
          </div>
          <div class="actionItem" @click="locationHandle()">
            <img
              class="iconImg"
              style="margin-right: 8rpx"
              src="../../../static/images/productDetail/position.png"
            />
            <div>点击导航</div>
          </div>
        </div>
      </div>
    </div>
    <div
      id="container"
      style="width: 100%; height: 300px; margin-bottom: 50px"
    ></div>
    <div class="footerSBox">
      <div class="footItem" @click="tabHandle(1)">
        <img
          src="../../../static/images/tabBar/menu1_on.png"
          class="homeIcon"
          v-if="active == 1"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu1_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">首页</div>
      </div>
      <div class="footItem" @click="tabHandle(2)">
        <img
          src="../../../static/images/tabBar/menu2_on.png"
          class="homeIcon"
          v-if="active == 2"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu2_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">产品</div>
      </div>
      <div class="footItem" @click="tabHandle(3)">
        <img
          src="../../../static/images/tabBar/menu3_on.png"
          class="homeIcon"
          v-if="active == 3"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu3_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">公司介绍</div>
      </div>
      <div class="footItem" @click="tabHandle(4)">
        <img
          src="../../../static/images/tabBar/menu4_on.png"
          class="homeIcon"
          v-if="active == 4"
          alt=""
        />
        <img
          src="../../../static/images/tabBar/menu4_off.png"
          class="homeIcon"
          v-else
          alt=""
        />
        <div class="footText">联系</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Image } from "vant";
import { companyInfo } from "@/api/store";
import { getShareData } from "@/utils/share";
export default {
  name: "companyIntro",
  components: {
    "van-image": Image,
  },
  data() {
    return {
      info: "",
      lat: 0,
      lng: 0,
      active: 3,
    };
  },
  methods: {
    //tab切换
    tabHandle(type) {
      if (type == 1) {
        this.active = 1;
        this.$router.push({
          path: "/storeShow",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 2) {
        this.active = 2;
        this.$router.push({
          path: "/product",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 3) {
        this.active = 3;
        this.$router.push({
          path: "/companyIntro",
          query: { mid: this.$route.query.mid },
        });
      } else if (type == 4) {
        this.active = 4;
        this.$router.push({
          path: "/contact",
          query: { mid: this.$route.query.mid },
        });
      } else {
      }
    },

    //获取公司介绍
    getCompanyInfo() {
      var that = this;
      var data = { MemberId: this.$route.query.mid, BusinessMemberId: 0 };
      companyInfo(data).then((res) => {
        that.info = res.Data;
        that.lat = res.Data.CompanyMap.point_x;
        that.lng = res.Data.CompanyMap.point_y;
        that.address = res.Data.CompanyAddress;
        that.init(that.lng, that.lat);
        getShareData(
          window.location.href,
          res.Data.Headline,
          that.Common.ToText(res.Data.Introduction).substr(0, 50),
          res.Data.Photo
        );
      });
    },

    //初始化地图
    init(lng, lat) {
      var myLatlng = new qq.maps.LatLng(lng, lat);
      var myOptions = {
        zoom: 12,
        center: myLatlng,
        mapTypeId: qq.maps.MapTypeId.ROADMAP,
      };

      var map = new qq.maps.Map(
        document.getElementById("container"),
        myOptions
      );

      var marker = new qq.maps.Marker({
        position: myLatlng,
        map: map,
      });
    },

    //点击跳转腾讯地图
    locationHandle() {
      var that = this;
      console.log(that.lng, that.lat);
      window.location.href =
        "https://apis.map.qq.com/tools/routeplan/eword=" +
        that.address +
        "&epointx=" +
        that.lng +
        "&epointy=" +
        that.lat +
        "?referer=myapp&key=47EBZ-MF42X-TEC42-Z563P-BLX67-C7FB5";
    },
  },

  created() {},
  mounted() {
    this.getCompanyInfo();
  },
  updated() {
    let DomList = document
      .getElementsByClassName("descriptionBox")[0]
      .querySelectorAll("img");
    for (let i in DomList) {
      if (DomList[i].style) {
        DomList[i].style.width = "100%";
        DomList[i].style.height = "auto";
      }
    }
  },
};
</script>
<style lang="less" scoped>
.container {
  .companyTopBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    .logoBox {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin: 48px 0 41px 0;
      .van-image {
        display: block;
        width: 150px;
        height: 150px;
        box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.16);
        background-color: #fff;
        /deep/ .van-image {
          border-radius: 5px;
          -webkit-border-radius: 5px;
          -moz-border-radius: 5px;
          -ms-border-radius: 5px;
          -o-border-radius: 5px;
        }
      }
    }
    .companyTitle {
      color: #333;
      font-size: 17px;
      font-weight: 800;
      margin-bottom: 23px;
    }
    .saleBox {
      box-sizing: border-box;
      width: 350px;
      margin: 0 auto;
      background: #f5f5f5;
      display: flex;
      flex-direction: column;
      font-size: 9px;
      color: #666;
      padding: 15px;
      .saleTitle {
        margin-bottom: 10px;
        font-weight: 800;
        font-size: 12px;
      }

      .saleInnerBox {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .saleItem {
          margin-right: 5px;
        }
      }
    }
  }
  .companyBox {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 0 13px;
    padding-bottom: 43px;
    .introduceBox {
      display: flex;
      flex-direction: column;
      font-size: 14px;
      padding-top: 21px;
      border-top: 1px solid #dddddd;
      .introduceItem {
        margin-bottom: 5px;
        .title {
          color: #999999;
          min-width: 50px;
          display: inline-block;
          text-align: justify;
          text-align-last: justify;
        }
        .content {
          color: #333;
        }
      }
      .actionBox {
        margin-top: 35px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .actionItem {
          width: 100px;
          height: 40px;
          box-sizing: border-box;
          border-radius: 5px;
          border: 1px solid #ccc;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #666;
          div {
            a {
              color: #666;
            }
          }
          .iconImg {
            width: 25px;
            height: 25px;
          }
        }
      }
    }
  }
  .descriptionBox {
    white-space: pre-wrap;
    width: 100%;
    word-wrap: break-word;
    table-layout: fixed;
    word-break: break-all;
    box-sizing: border-box;
    padding: 22px 13px;
    font-size: 14px;
    text-align: justify;
  }
}
</style>

